module.exports = __webpack_public_path__ + "img/film.517f1d70.svg";